export default class Place {
   id?: string;
   name: string;
   address?: string;
   lat: number = 0;
   lng: number = 0;
   picName?: string;
   picMobile?: string;
}
